/* eslint-disable no-constant-condition */
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import * as Dialog from '@radix-ui/react-dialog';
import { Subscription } from '../../../types/Subscription';
import { PricingPlan } from '../../../types/Pricing';
import { PricingTabs } from './PlansModel';
import { useState } from 'react';
import { Link,  } from 'react-router-dom';
import {  Typography } from '@mui/material';


type ChangePlanButtonProps = {
  pricingPlans: PricingPlan[];
  subscription: Subscription;
  planPeriod: string;
  trigger?: React.ReactNode;
  setOpen?: (open: boolean) => void;
  open?: boolean
};

const ChangePlanButton = ({ pricingPlans, subscription, planPeriod, trigger, setOpen, open }: ChangePlanButtonProps) => {

  const isControlled = open !== undefined;

  const [internalOpen, setInternalOpen] = useState(false);
  const [activeTab] = useState(planPeriod);


  const handleClose = () => {
    if (setOpen) {
      setOpen(false);
    }
  };


  return (
    <Dialog.Root
      open={isControlled ? open : internalOpen}
      onOpenChange={isControlled ? setOpen : setInternalOpen}
    >

      <Dialog.Trigger asChild>
        {trigger}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-[#1b1d1eb3] data-[state=open] :animate-overlayShow transition-opacity duration-300 " />



        <Dialog.Content className={'data-[state=open]:animate-contentShow fixed z-[9999]  top-[55%] md:top-[50%] left-[50%] overflow-hidden md:h-auto md:w-full md:mt-0 md:min-w-[150px] md:max-w-[600px] w-[90%]  lg:max-w-[1200px] translate-x-[-50%] translate-y-[-50%] rounded-[10px] bg-black md:p-6 p-4 shadow-xl focus:outline-none '}>

          <Dialog.Title className="text-sm m-0 text-[18px] font-semibold flex justify-between items-center">
            <p className="font-bold text-white text-lg text-[24.19px] font-[500]"></p>
            <Dialog.Close asChild>
              <button onClick={handleClose} className="text-xs bg-transparent text-white hover:text-gray-400 inline-flex h-[35px] items-center justify-center rounded-full px-3 transition-all duration-200">
                <CancelRoundedIcon className="cursor-pointer w-5 h-5" />
              </button>
            </Dialog.Close>
          </Dialog.Title>

          <div className='flex flex-col items-center justify-center w-full overflow-x-hidden '>
            {/* <div className="flex justify-center mt-10 border border-[#393939] w-fit mx-auto rounded-[70px] bg-[#18181B]  p-2 items-center">
              <button
                className={`flex px-4 py-2 justify-center items-center gap-[5px] rounded-full text-[14px] font-semibold ${activeTab === 'month' ? 'bg-[#1937E0] text-white' : 'text-[#CDCDCD]'}`}
                onClick={() => setActiveTab('month')}
              >
                Monthly
              </button>
              <button
                className={`flex px-4 py-2 justify-center items-center gap-[5px] rounded-full text-[14px] font-semibold ${activeTab === 'year' ? 'bg-[#1937E0] text-white' : 'text-[#CDCDCD]'}`}
                onClick={() => setActiveTab('year')}
              >
                Yearly
              </button>
            </div>
             */}
            <div className="relative w-full text-center mt-4">
              <span className="text-white font-[900] text-[20px] md:text-[30px]">
                Subscription Plans
              </span>
              <Typography
                variant="body2"
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: '71%',
                  transform: 'translateY(-50%)',
                  mt:-0.5,
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  fontStyle: 'normal',
                  fontSize: '14px',
                  lineHeight: '100%',
                  letterSpacing: 0,
                  verticalAlign: 'middle',
                  textDecoration: 'underline',
                  textDecorationStyle: 'solid',
                  textDecorationThickness: 0,
                  textDecorationOffset: '0%',
                  color: '#FFFFFF',
                  cursor: 'pointer',
                  display: 'inline-block',
                  pt: { xs: 5, md: 0 },

                }}
              >
                <Link to={`/creator/dashboard`}>I will do this later</Link>
              </Typography>
              {/* <Link
                // component={RouterLink}
                to={`/creator/dashboard`}
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: '62%',
                  transform: 'translateY(-50%)',
                  color: '#ffffffff', // tailwind's blue-500
                  pr: { xs: 2, md: 0 },
                }}
              > I will do this later </Link> */}
            </div>



            {pricingPlans && <PricingTabs subscription={subscription} planPeriod={activeTab} plans={pricingPlans} isUserAlreadySubscribed={!subscription?.free && subscription?.active} />}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ChangePlanButton;
